// base url — use REACT_APP_API_URL for local (http://localhost:8001/api) else prod
export const BASE_URL = process.env.REACT_APP_API_URL || 'https://api.pyqpedia.com/api';
export const Base_Api = 'https://backend-api-tmnu.onrender.com';

export const Dummy_BASE_URL = 'https://backend-api-tmnu.onrender.com';
export const Dummy_Course = '/items';


// ----------------------------------------Student dashboard------------------------------------------------
// menu
export const courseApi = `/menu`;
export const menuStatusApi = `/menu/status`;

// students
export const studentsApi = `/users`;
export const studentsStatusApi = `/users/status`;

// download
export const downloadApi = `/downloads`;

// upcoming batches
export const batchesApi = `/batches`

// current affairs
export const currentAffairsApi = `/currentaffairs`;

// packages
// export const packagesApi = `/packages`;
export const packagesApi = `https://test.pyqpedia.com/api/Packages/index.json`;
// export const packagesDetailsApi = `https://test.pyqpedia.com/Packages/singleproduct/${id}`;

// objective quiz
export const objectivequizApi = `/objectivetest`;

// objective quiz report
export const objectivequizReportApi = `/admin/objectivereport`;

// objective quiz report
export const subjectivequizReportApi = `/admin/subjectivereport`;

// subjective quiz
export const subjectivequizApi = `/subjectivetest`;

// full mock test
export const fullmocktestApi = `/fullmocktest`;

// recent vacancy
export const recentvacancyApi =`/recentvacancies`;


// blogs
export const blogsApi = `/blogs`;
export const blogsStatusApi = `/blogs/status`;

// study material
export const studyMaterialApi = `/studymaterials`;
export const studyMaterialStatusApi = `/study-material/status`;

// subjects
export const subjectsApi = `/subjects`;
export const subjectsStatusApi = `/subjects/status`;

// topics
export const topicsApi = `/topics`;
export const topicsBySubjectApi = `/topics/bysubject`;
export const topicsStatusApi = `/topics/status`;

// questions
export const questionsAPI = `/questions`;
export const questionsStatusAPI = `/questions/status`;


// mock tests
export const mockTestsApi = `/tests`;
export const mockTestsStatusApi = `/tests/status`;
export const mockTestsByTopicsApi = `/questions/bytopics`;

//----------- free initiative ------------
// answer writing questions
export const answerWritingQuestionsApi = `/answerwritingquestions`;
export const practicePyqQuestionsApi = `/practicepyq`;
export const practicePyqQuestionsByIdApi = `/practicepyqbyid`;
export const currentAffairsQuizQuestionsApi = `/currentaffairsquiz`;
export const mixContentQuestionsApi = `/mixedcontents`;


// -----------------------------------------------------auth------------------------------------------------
export const loginApi = `/login`;
export const changePasswordApi = `/users/changepassword`;

// auth county
export const countriesApi = `/countries`;

// auth state
export const statesApi = `/states`;

// auth city
export const citiesApi = `/cities`;

// message
export const Dum_BASE_URL = `https://backend-api-tmnu.onrender.com`;
export const messagesApi = `/items`;

export const FullMockApi = `/items`;

export const noticeApi = `/notices`;

export const sliderApi = `/sliders`;

export const testimonialApi = `/testimonials`;